import config from '../config/config';

const getCFUrl = (key) => `${config.cloudFrontDomain}${key}`;
export default getCFUrl;
